;(function () {
  angular
    .module('contrast.org.dashboard')
    .controller('DashboardTTRCtrl', DashboardTTRCtrl)

  function DashboardTTRCtrl(
    $scope,
    $timeout,
    $routeParams,
    permissions,
    ErrorService,
    TrendService,
    ChartService,
    LoadFilterRouteService,
    orgTraceApiConfig,
    csVulnerabilityViolationsService,
    TIME_SERIES_DATES_TODAY,
    SUBFILTERS,
    UserService
  ) {
    'ngInject'

    angular.extend($scope, {
      model: {
        time: TIME_SERIES_DATES_TODAY[1],
        selectedTypeRange: getFilterTypeForTTR(),
        selectedDateRange: undefined,
        trendData: {},
        timeData: {},
        vulnViolationsCount: csVulnerabilityViolationsService.getCount()
      },

      statsPromise: false
    })

    $scope.$watch(
      function () {
        return csVulnerabilityViolationsService.getCount()
      },
      function () {
        $scope.model.vulnViolationsCount =
          csVulnerabilityViolationsService.getCount()
      }
    )

    angular.extend($scope, {
      isTtrDropdownVisible: isTtrDropdownVisible,
      onTtrRangeTypeSelected: onTtrRangeTypeSelected,
      onTtrDateRangeSelected: onTtrDateRangeSelected,
      onTTRValueClick: onTTRValueClick,
      getFilterTypeForTTR: getFilterTypeForTTR
    })

    function init() {
      $scope.model.selectedDateRange = getRelativeRange({
        count: 30,
        unit: 'DAYS',
        type: 'RELATIVE_TO_NOW'
      })

      $timeout(function () {
        getTTRStats().then(function () {
          $scope.statsPromise = true
        })
      }, 0)
    }

    function onTtrRangeTypeSelected(e) {
      $scope.model.selectedRangeType = e

      getTTRStats()
    }

    function onTtrDateRangeSelected(e) {
      $scope.model.selectedDateRange = e

      getTTRStats()
    }

    function isTtrDropdownVisible() {
      return permissions.isEOP() || $routeParams.showTtrDropdown
    }

    function onTTRValueClick(severity) {
      var filters = {
        quickFilter: 'ALL'
      }
      filters[SUBFILTERS.VULNS.ENUM.SEVERITY] = [severity.toUpperCase()]
      filters[SUBFILTERS.VULNS.ENUM.STATUS] = [
        'Fixed',
        'Remediated',
        'AutoRemediated'
      ]

      LoadFilterRouteService.goToOrganizationVulnerabilities(filters)
    }

    function getFilterTypeForTTR() {
      return UserService.getCurrentOrganization().properties
        .default_filter_type_for_ttr
    }

    function getTTRStats() {
      var params = isTtrDropdownVisible()
        ? {
            startTime:
              $scope.model.selectedDateRange.startDate &&
              $scope.model.selectedDateRange.startDate.valueOf(),
            endTime:
              $scope.model.selectedDateRange.endDate &&
              $scope.model.selectedDateRange.endDate.valueOf(),
            filterType: $scope.model.selectedRangeType
          }
        : {}

      return orgTraceApiConfig.getTraceTTRTrendBySeverity(params).then(
        function (response) {
          $scope.model.trendData = TrendService.getTraceTTRSeverityData(
            response.data
          )
          $scope.model.timeData = ChartService.buildTraceRemediationData(
            response.data
          )
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function getRelativeRange(item) {
      const endDate = new Date()

      const startDate = new Date(endDate)

      switch (item.unit) {
        case 'MINUTES':
          startDate.setMinutes(endDate.getMinutes() - item.count)
          break
        case 'HOURS':
          startDate.setHours(endDate.getHours() - item.count)
          break
        case 'DAYS':
          startDate.setDate(endDate.getDate() - item.count)
          break
        case 'WEEKS':
          startDate.setDate(endDate.getDate() - item.count * 7)
          break
        case 'MONTHS':
          startDate.setMonth(endDate.getMonth() - item.count)
          break
        case 'YEARS':
          startDate.setFullYear(endDate.getFullYear() - item.count)
          break
      }

      item.startDate = startDate
      item.endDate = endDate

      return item
    }

    init()
  }
})()
